import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';

interface ToiletsProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeTask: any;
  completeChallenge: Function;
  generalData: Function;
  getOffers: Function;
}

const Toilets: React.FC<ToiletsProps> = (props) => {
  const {
    challenges,
    listLocation,
    getChallengeCategory,
    completeTask,
    completeChallenge,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');

  const loadingChallenges = _.get(challenges, 'status.loading');
  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });
  const [t] = useTranslation('common');
  const { error, loading, done } = _.get(completeTask, 'status');
  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'toilets');
    getOffers(getRoomId);
  }, [getRoomId]);
  const pageArray = [
    {
      id: 266,
      title: 'Dual flush toilets',
      icon: 'toilet',
      description:
        'Dual flush toilets can be huge water wasters, with staff pressing the wrong button and leaks that go undetected.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Print off the poster and place beside in each toilet cubicle to remind staff to turn press the correct button after use. This poster will help reduce cold & hot water use in your business by as much as 30%.',
          ],
          buttonText: 'Download PDF',
          buttonIcon: 'download',
          linkType: 'button',
          buttonPath:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/koala.pdf',
          poster:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/koala.png',
        },

        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'toilet',
          hasLogo: false,
          description: [
            'Even small leaks waste a surprising amount of water so do check toilets regularly. To look for minor leaks, place a sheet of toilet paper at the back of the pan. Any water leaking from the cistern will make the tissue wet.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,

          description: [
            'Once a toilet begins to leak, it’s important to get it fixed. A small dribble is likely to turn into a constant flow of water, which if left unchecked, could waste up to 400 litres every day – adding significantly to the running costs of your business.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'half',
          hasLogo: true,
          icon: null,
          linkType: 'externalLink',
          buttonText: 'Find cistern replacement valves',
          buttonPath:
            'https://uk.getwatersmart.com/products?category=BathroomToilets',
          description: [
            'There are many products available to fix a leaking cistern, with several replacing the entire dual flush flushing mechanism with a guaranteed leak-free siphon, appropriate for dual flush toilets.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'toilets');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };
  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  return (
    <Wrap>
      <EasyWin data={pageArray}>
        <Row style={{ marginTop: '16px' }}>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default Toilets;
